import { constructionSafety, logisticsAsset, logisticsSafety, manufacturingSteel } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';
import digitaltwin from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

export default {
  desc: 'Chuyển đổi số là quá trình đổi mới các doanh nghiệp và xã hội hiện có bằng công nghệ kỹ thuật số. Nói cách khác, đó là quá trình cải thiện hiệu quả và đổi mới công việc, dịch vụ, giao tiếp, v.v., bằng cách áp dụng công nghệ kỹ thuật số vào các phương thức truyền thống. ',
  keywords: 'DigitalTransformation,DigitalTwin,DX,SmartCity',
  ogSite: 'Chuyển đổi số (Digital Transformation) là gì?',
  title: 'Chuyển đổi số (Digital Transformation) là gì?',
  ogUrl: 'https://orbro.io/vi/blog/what-is-digital-transformation',
  ogImg: '',
  ogType: 'website',
  date: '2024-01-10',
  tag1: '#DigitalTransformation',
  tag2: '#DigitalTwin',
  tag3: '#DX',
  tag4: '#SmartCity',
  text: [
    {
      head: 'Chuyển đổi số (Digital Transformation) là gì?',
      subHead: '',
      desc: 'Chuyển đổi số là quá trình đổi mới các doanh nghiệp và xã hội hiện có bằng công nghệ kỹ thuật số. Nói cách khác, đó là quá trình cải thiện hiệu quả và đổi mới công việc, dịch vụ, giao tiếp, v.v., bằng cách áp dụng công nghệ kỹ thuật số vào các phương thức truyền thống. Điều này chủ yếu nhằm mục tiêu tái cấu trúc các mô hình và quy trình kinh doanh bằng cách sử dụng các công nghệ như Big Data, Cloud Computing, Trí tuệ nhân tạo (AI), tự động hóa, từ đó nâng cao năng suất và tăng cường năng lực cạnh tranh. Do đó, chuyển đổi số không chỉ là một sự thay đổi về công nghệ mà còn ảnh hưởng đến văn hóa tổ chức và cách thức làm việc, và có thể được hiểu là một quá trình thay đổi liên tục kéo dài đến tương lai.',
      dot: '',
    },
    {
      head: 'Các đặc điểm chính của Chuyển đổi số',
      subHead: 'Quản lý dựa trên Dữ liệu (Data-Driven Management)',
      desc: 'Các doanh nghiệp thu thập và phân tích lượng lớn dữ liệu để đưa ra các quyết định kinh doanh chính xác. Điều này giúp dự đoán hành vi khách hàng và xây dựng chiến lược thông qua công nghệ và phân tích Big Data.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tự động hóa và Trí tuệ nhân tạo (Automation and Artificial Intelligence)',
      desc: 'Tự động hóa quy trình làm việc giúp nâng cao năng suất của doanh nghiệp, và việc áp dụng công nghệ AI cho phép thực hiện hiệu quả các tác vụ phức tạp như phân tích dự đoán, xử lý ngôn ngữ tự nhiên, nhận diện hình ảnh. Điều này mang lại hiệu quả giảm gánh nặng công việc cho con người.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Điện toán đám mây (Cloud Computing)',
      desc: 'Công nghệ đám mây cho phép sử dụng linh hoạt tài nguyên IT, giúp doanh nghiệp cắt giảm chi phí hạ tầng và có thể mở rộng hoặc thu hẹp tài nguyên khi cần. Nhờ đó, quy trình làm việc có thể được vận hành một cách linh hoạt hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Internet vạn vật (Internet of Things, IoT)',
      desc: 'Internet vạn vật là khái niệm về việc các thiết bị vật lý được kết nối với nhau để trao đổi dữ liệu và tương tác. Nó được áp dụng trong nhiều lĩnh vực đa dạng, từ tối ưu hóa dây chuyền sản xuất trong ngành sản xuất, đến điều khiển tiện lợi trong nhà thông minh và giám sát trong lĩnh vực chăm sóc sức khỏe, từ đó nâng cao hiệu quả và thúc đẩy đổi mới.',
      dot: '',
    },
    {
      head: 'Các trường hợp Chuyển đổi số điển hình',
      subHead: '',
      desc: 'Chuyển đổi số đang diễn ra trong nhiều ngành công nghiệp và doanh nghiệp khác nhau, và mỗi trường hợp lại thể hiện một cách thức riêng biệt trong việc áp dụng công nghệ kỹ thuật số để đổi mới kinh doanh hoặc tối ưu hóa quy trình. Dưới đây là một số ví dụ điển hình về chuyển đổi số:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành Dịch vụ Tài chính - FinTech:',
      desc: 'Chuyển đổi số trong ngành dịch vụ tài chính đang được thúc đẩy bởi các công ty FinTech, những người đang thách thức hệ thống ngân hàng truyền thống. Việc áp dụng các công nghệ như mobile banking, hệ thống thanh toán điện tử, robot đầu tư, v.v., đang cung cấp cho khách hàng các dịch vụ tiện lợi và chi phí thấp hơn. Các ví dụ điển hình về FinTech bao gồm giao dịch ngân hàng qua ứng dụng di động, nền tảng đầu tư trực tuyến, và ứng dụng quản lý tài chính cá nhân.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành Sản xuất - Nhà máy Thông minh (Smart Factory):',
      desc: 'Chuyển đổi số trong ngành sản xuất được thể hiện qua khái niệm Nhà máy thông minh (Smart Factory). Việc ứng dụng IoT, Big Data và công nghệ AI giúp tối ưu hóa dây chuyền sản xuất và nâng cao hiệu quả bằng cách phân tích dữ liệu sản xuất theo thời gian thực. Các ví dụ về Smart Factory bao gồm giám sát dây chuyền sản xuất thông qua cảm biến và công nghệ IoT, dự đoán bảo trì thông qua phân tích Big Data, và tối ưu hóa quy trình sản xuất bằng robot và tự động hóa.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Ngành Bán lẻ - Mua sắm Trực tuyến và Tiếp thị Cá nhân hóa:',
      desc: 'Chuyển đổi số trong ngành bán lẻ tập trung vào các nền tảng mua sắm trực tuyến và tiếp thị cá nhân hóa. Các ví dụ về chuyển đổi số của các nhà bán lẻ bao gồm hệ thống đề xuất cá nhân hóa dựa trên phân tích dữ liệu, phòng thử đồ ảo và quản lý tồn kho theo thời gian thực. Việc phân tích lịch sử mua hàng của khách hàng để đề xuất sản phẩm phù hợp, trải nghiệm mua sắm trực tuyến qua phòng thử đồ ảo, và hệ thống thanh toán kỹ thuật số tại cửa hàng là những ví dụ điển hình.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Lĩnh vực Y tế - Hồ sơ Sức khỏe Điện tử (EHR):',
      desc: 'Chuyển đổi số trong lĩnh vực y tế tập trung vào việc triển khai hệ thống Hồ sơ sức khỏe điện tử (EHR) và chẩn đoán, giám sát từ xa thông qua công nghệ Telemedicine. Việc quản lý dữ liệu bệnh nhân bằng kỹ thuật số và cung cấp dịch vụ y tế trực tuyến giúp nâng cao hiệu quả. Việc triển khai hệ thống EHR, nền tảng cuộc gọi video cho khám chữa bệnh từ xa, và các cảm biến giám sát tình trạng sức khỏe của bệnh nhân theo thời gian thực có thể được xem là các trường hợp chuyển đổi số trong lĩnh vực y tế.',
      dot: '',
    },
    {
      head: 'Các Công nghệ Cốt lõi của Chuyển đổi số',
      subHead: 'Trí tuệ nhân tạo (Artificial Intelligence, AI)',
      desc: 'AI bao gồm các công nghệ cho phép hệ thống máy tính có khả năng học hỏi, suy luận và giải quyết vấn đề tương tự con người. Machine Learning, Deep Learning, xử lý ngôn ngữ tự nhiên, v.v., được sử dụng làm các lĩnh vực con của AI, và thông qua đó, có thể thực hiện nhiều tác vụ khác nhau như phân tích dữ liệu, phân tích dự đoán, tự động hóa.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Big Data',
      desc: 'Big Data là công nghệ thu thập, lưu trữ và phân tích các loại dữ liệu lớn và đa dạng. Việc sử dụng lượng lớn dữ liệu giúp khám phá các mẫu thống kê, xu hướng, và hiểu biết sâu sắc, hỗ trợ các quyết định kinh doanh. Nó được liên kết với Cloud Computing để xử lý và lưu trữ dữ liệu dung lượng lớn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Điện toán đám mây (Cloud Computing)',
      desc: 'Điện toán đám mây là công nghệ cung cấp tài nguyên máy tính (máy chủ, lưu trữ, mạng, v.v.) qua internet, cho phép điều chỉnh tài nguyên một cách linh hoạt theo nhu cầu. Các doanh nghiệp có thể tiết kiệm chi phí hạ tầng và cung cấp dịch vụ nhanh chóng thông qua đám mây.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Internet of Things (IoT)',
      desc: 'IoT là công nghệ nhúng cảm biến và chức năng truyền thông vào các vật thể để chúng có thể kết nối và tương tác với nhau qua internet. Thông qua đó, các thiết bị đa dạng có thể thu thập dữ liệu và giao tiếp với nhau, làm cho môi trường sống và làm việc trở nên thông minh hơn.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Robot và Tự động hóa (Robotics and Automation)',
      desc: 'Công nghệ robot và tự động hóa đề cập đến các công nghệ mà máy móc thay thế hoặc hợp tác với con người để thực hiện các công việc. Nó được ứng dụng không chỉ trong ngành sản xuất mà còn trong ngành dịch vụ, giúp nâng cao năng suất và hiệu quả.',
      dot: '',
    },
    {
      head: 'Lợi ích của Chuyển đổi số',
      subHead: 'Giành được Lợi thế Cạnh tranh',
      desc: 'Chuyển đổi số có thể giúp doanh nghiệp giành được lợi thế cạnh tranh thông qua việc giới thiệu các mô hình kinh doanh mới và tối ưu hóa các quy trình hiện có. Việc tận dụng dữ liệu hiệu quả và cung cấp dịch vụ tốt hơn có thể mang lại nhận diện thương hiệu lớn hơn và đánh giá tích cực trên thị trường.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Cải thiện Trải nghiệm Khách hàng',
      desc: 'Chuyển đổi số lấy khách hàng làm trung tâm giúp nâng cao trải nghiệm khách hàng. Các dịch vụ cá nhân hóa, giao diện kỹ thuật số tiện lợi, phản hồi nhanh chóng, v.v., mang đến cho khách hàng trải nghiệm tốt hơn và góp phần tăng lòng trung thành.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Giảm Chi phí và Nâng cao Hiệu quả',
      desc: 'Việc áp dụng các công nghệ kỹ thuật số như tự động hóa, điện toán đám mây, phân tích dữ liệu giúp các quy trình làm việc trở nên hiệu quả hơn, giảm chi phí và nâng cao năng suất. Thực hiện công việc nhanh hơn và chính xác hơn giúp sử dụng hiệu quả nhân lực và tài nguyên.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Tăng cường Khả năng Ứng phó Thị trường',
      desc: 'Chuyển đổi số giúp doanh nghiệp ứng phó với môi trường thị trường thay đổi nhanh chóng. Các mô hình kinh doanh linh hoạt và quyết định dựa trên dữ liệu giúp phản ứng nhanh chóng với sự thay đổi. Ngoài ra, việc áp dụng công nghệ mới và thay đổi các mô hình kinh doanh hiện có thúc đẩy đổi mới và tạo ra các cơ hội mới. Điều này có thể thể hiện qua nhiều hình thức như gia nhập thị trường mới, đổi mới sản phẩm, hình thành quan hệ đối tác.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/vi/enterprise/construction/safety',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/vi/enterprise/logistics/safety',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/vi/enterprise/manufacturing/steel',
      },
    ],
  },
};
